const defaultDesignOptions = {
  button_border_radius: 30,
  button_text_color: '',
  custom_form_width: 55,
  footer_alignment: 'center',
  footer_background_color: '',
  footer_color: '',
  footer_padding: 40,
  form_background: 'FFFFFF',
  form_background_image: '',
  form_background_image_fixed: false,
  form_background_image_repeat: false,
  form_background_image_size: 'cover',
  form_background_transparency: 100,
  form_background_type: 'fill',
  form_body_label_color: '',
  form_body_label_transform: 'default',
  form_body_padding: 21,
  form_border_radius: 14,
  form_direction: 'default',
  form_field_background_color: '',
  form_field_border_color: '',
  form_field_border_radius: 4,
  form_field_color: '',
  form_layout: 'default_layout',
  header_alignment: 'center',
  header_background_color: '',
  header_color: '',
  header_line_height: '',
  header_padding: 21,
  label_orientation: 'default',
  logo_placement: 'header',
  page_background_blur: '',
  page_background_type: 'fill',
  secondary_button_background_color: '',
  secondary_button_color: '',
  theme: 'None',
  page_gradient_type: 'linear',
  page_gradient_shape: 'ellipse',
  page_gradient_direction: 'to right',
  page_gradient_start_color: '',
  page_gradient_end_color: '',
  form_gradient_type: 'linear',
  form_gradient_shape: 'ellipse',
  form_gradient_direction: 'to right',
  form_gradient_start_color: '',
  form_gradient_end_color: '',
};

const defaultFormOption = {
  layout_class: null,
  submission_button_text: null,
  save_continue_button_text: null,
  previous_button_text: null,
  next_button_text: null,
  submission_button_background: null,
  submission_button_position: 'right',
  multipage_buttons_position: 'left',
  submission_button_type: 'rounded',
  custom_logo_image: null,
  custom_logo_alignment: 'centered',
  page_background: null,
  form_text_color: null,
  form_font: null,
  form_font_size: '14px',
  form_title_font_size: '28px',
  form_external_css: null,
  form_background_image: null,
  custom_form_width: null,
  background_image_size: 'cover',
  background_image_fixed: false,
  background_image_repeat: false,
};

const blankDesignTheme = {
  name: 'None',
  form_id: null,
  design: defaultDesignOptions,
  form_model: defaultFormOption,
};

export default blankDesignTheme;
